import React, { Component } from 'react';
import * as Sentry from '@sentry/browser';

import ErrorScreen from './shared/ui/components/error-screen/ErrorScreen';
import { initSentry } from './sentry';

const whitelist = ['ChunkLoadError'];

const isLogging = initSentry(Sentry);

class ErrorBoundary extends Component {
  state = {
    error: null,
  };

  componentDidCatch(error, errorInfo) {
    if (whitelist.includes(error?.name)) {
      window.location.reload(true);
    } else if (isLogging) {
      Sentry.withScope((scope) => {
        scope.setExtras(errorInfo);
        Sentry.captureException(error);
      });

      this.setState({ error });
    }
  }

  render() {
    const { error } = this.state;
    const { children } = this.props;

    return error ? <ErrorScreen error={error} /> : children;
  }
}

export { ErrorBoundary };
